<template>
  <PvCard>
    <template #title>
      <h2 class="fs-2">REPORT STATUS STATISTICS BY REPORT TYPE</h2>
    </template>
    <template #content>
      <div class="pb-2 d-flex flex wrap gap-2 align-items-center">
        <span for="select-filter">Report Year</span>
        <PvSelect :options="dashboardStore.availableYears" 
                  optionLabel="label"
                  optionValue="value"
                  inputId="select-filter"
                  aria-label="Report year"
                  v-model="selectedReportYear"
                  @change="handleReportYearChange"
                  :style="{ width: '7rem' }" />
      </div>
      <hr />
      <PvDataTable :value="dashboardStore.reportStatusCounts"
                   tableStyle="min-width: 50rem"
                   size="small" >
        <PvColumn v-for="col in gridColumns" 
                  :key="col.field"
                  :field="col.field"
                  :header="col.header"
                  :class="col.class ? col.class : undefined"
                  :style="col.width ? { width: col.width } : undefined"  />
        <template #empty>
          <NoData message="No report status statistics available." /> 
        </template>
      </PvDataTable>
    </template>
    <template #footer>
      <div class="text-center mt-3">
        <PvButton label="Review Annual Reports"
                  class="px-5"
                  @click="handleReviewAnnualReports"
                  rounded />
      </div>
    </template>
  </PvCard>
</template>

<script setup>
// ===============================
// IMPORTS
// ===============================
// Vue Core
import { onMounted } from 'vue';


// Components
import NoData from '@/components/common/NoData.vue';

// Composables
import { storeToRefs } from 'pinia';
import { usePageHelper } from '@/composables/pageHelper';

// Stores
import { useProgramDashboardStore } from '../stores/ProgramDashboardStore';
import { useAppStore } from '@/stores/appStore';

// Constants and Utils


// ===============================
// PROPS & EMITS
// ===============================


// ===============================
// COMPOSABLES & STORES
// ===============================
const dashboardStore = useProgramDashboardStore();
const { selectedReportYear } = storeToRefs(dashboardStore);
const { setPageFilter } = useAppStore();
const pageHelper = usePageHelper();


// ===============================
// REACTIVE STATE
// ===============================

// ===============================
// CONSTANTS
// ===============================
const gridColumns = [
  { field: 'reportType', header: 'Report Type', width: '125px' },
  { field: 'reportsExpected', header: 'Reports Expected', width: '100px', class: 'text-center' },
  { field: 'notSubmitted', header: 'Not Submitted', width: '100px', class: 'text-center' },
  { field: 'informationRequired', header: 'Information Required', width: '100px', class: 'text-center' },
  { field: 'readyForReview', header: 'Ready For Review', width: '100px', class: 'text-center' },
  { field: 'underReview', header: 'Under Review', width: '100px', class: 'text-center' },
  { field: 'reviewComplete', header: 'Review Complete', width: '100px', class: 'text-center' },
];

// ===============================
// COMPUTED PROPERTIES
// ===============================


// ===============================
// METHODS
// ===============================
const handleReportYearChange = async () => {
  await pageHelper.fetch(() => dashboardStore.fetchReportStatusCounts(selectedReportYear.value), null, true);
};

const handleReviewAnnualReports = () => {
  setPageFilter('annualReports:reportYear', selectedReportYear.value);
  pageHelper.navigateToRouteName('programannualreports');
};

// ===============================
// WATCHERS
// ===============================


// ===============================
// LIFECYCLE HOOKS
// ===============================
onMounted(() => {
  if (dashboardStore.availableYears.length > 0) {
    selectedReportYear.value = dashboardStore.availableYears[0].value;
  }
});

// ===============================
// EXPOSE
// ===============================


</script>
